import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { Division } from "../models/division";
import { FilterDivisions } from "../models/filters/filter-division";

@Injectable({
providedIn: 'root'
})
export class DivisionService {

    constructor(private http: HttpClient) { }

    private apiUrl = `${environment.apiUrl}`;
    private url: string = this.apiUrl + 'api/divisions'; 

    /*CRUD CATALOG DIVISION*/
    /*getAllDivisions(): Observable<any>{
        return this.http.get<any[]>(`${this.url}/getAllDivisions`);
    }*/

    findAllPageableDivisions(filterDivisions: FilterDivisions, page: number, pageSize: number): Observable<any> {
        return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterDivisions);
    }

    getDivisionById(id: number): Observable<Division>{
        return this.http.get<Division>(`${this.url}/getDivisionById/${id}`)
    }

    saveDivision(division: Division): Observable<Division>{
        return this.http.post<Division>(`${this.url}/saveDivision`, division)
    }

    updateDivision(division: Division): Observable<Division>{
        return this.http.put<Division>(`${this.url}/updateDivision/${division.id}`, division)
    }
    /*CRUD CATALOG DIVISION*/


}